module.exports = __webpack_public_path__ + "img/1.cb82134d.jpg";